<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('announcement')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Edit Announcement</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <base-input
          alternative
          class="mb-3"
          name="heading"
          :rules="{ required: true }"
          placeholder="Heading"
          v-model="heading"
        >
        </base-input>

        <div
          class="text-sm text-gray-600 font-medium px-2 py-1 mb-1 border rounded bg-gray-100 inline-block"
        >
          Recommended Size: 1100px × 450px
        </div>
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />
        <div class="flex cursor-pointer items-center my-2" v-if="image">
          <base-button type="danger" class="px-8" @click="handleRemove">
            Remove image
          </base-button>
        </div>
        <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>

        <img v-if="image" :src="image" ref="cover" />

        <div class="mt-3 mb-4">
          <p class="mb-2">Uploaded Image</p>
          <img class="w-1/2" :src="$imageURL + '/' + image2" alt="" />
          <base-button
            v-if="image2"
            type="danger"
            class="px-8"
            @click="handleRemove"
          >
            Remove image
          </base-button>
        </div>

        <div class="py-4 customboxed">
          <p class="mb-1">Announcement Link</p>
          <base-input
            class="mb-3"
            name="Link"
            :rules="{
              required: true,
              regex:
                '(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?',
            }"
            placeholder="Add your announcement link"
            v-model="link"
          >
          </base-input>
          <span v-if="linkErr" class="small text-danger">{{ msg.link }}</span>
        </div>
        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Save</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      title: "",
      heading: "",
      link: "",
      image: "",
      coverImage: "",

      blog_data: {},

      editorOption: {
        theme: "snow",
      },
      linkErr: false,
      imageErr: false,
      msg: {
        image: "",
      },
    };
  },

  watch: {
    // pageData(val) {
    //   this.blog_data = { ...val };
    //   console.log(this.blog_data);
    // },
  },
  methods: {
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;

        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      let FormData = require("form-data");
      let data = new FormData();
      //data.append("type", "single");
      data.append("_id", this.selecthomebanner._id);
      data.append("heading", this.heading);
      data.append("image", this.coverImage);
      data.append("link", this.link);
      let loader = this.$loading();
      try {
        const pattern = /^(https?|http?):\/\/[^\s$.?#-+].[^\s]*$/;
        if (!pattern.test(this.selecthomebanner.link)) {
          this.linkErr = true;
          this.msg.link = "Enter a valid url";
          loader.close();
          return;
        } else {
          const editData = await this.$store.dispatch(
            "services/edithomebanner",
            data
          );
          if (editData.code == 200) {
            this.$router.push({ name: "announcement" });
            this.$swal.fire({
              text: "Announcement Successfully Edited",
              icon: "success",
              confirmButtonText: "Okay",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
          }

          loader.close();
        }
      } catch (error) {
        console.log(error);
        // if (error) {
        //   loader.close();
        // }
      }
    },
    async init() {
      // console.log(this.selecthomebanner);
      this.blog_data = { ...this.selecthomebanner };
      this.heading = this.selecthomebanner.heading;
      this.link = this.selecthomebanner.link;
      this.image2 = this.selecthomebanner.image;
    },
    handleRemove() {
      this.image = null;
      this.image2 = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  computed: {
    ...mapState("services", {
      selecthomebanner: "selecthomebanner",
    }),
  },
  mounted() {
    this.init();
  },
};
</script>
